module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d2c646eaa2c55f306468b28d7cedd554.png";